module.exports = __webpack_public_path__ + "static/img/npm.0d1c7bbe.png";